module.exports = __webpack_public_path__ + "static/media/selectfilterPro.44eee549.svg";